module.exports = __webpack_public_path__ + "img/reports-backdrop.4070badb.jpg";